import * as React from 'react';

import RecentFiles140 from './RecentFiles140';

export const recentFiles140 = () => <RecentFiles140 />;

export default {
    title: 'Illustration/RecentFiles140',
    component: RecentFiles140,
    parameters: {
        notes: "`import RecentFiles140 from 'box-ui-elements/es/illustration/RecentFiles140';`",
    },
};
